import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { Icon } from '@/ui';

import type { FC, MouseEventHandler } from 'react';

interface SummaryLinkProps {
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  to: string;
}

const SummaryLink: FC<SummaryLinkProps> = ({ className, onClick, to }) => (
  <Link
    className={clsx(
      'mt-1 inline-flex items-center gap-2 self-start text-sm font-bold text-cement-600 underline decoration-solid',
      className,
    )}
    to={to}
    onClick={onClick}
  >
    <Icon className="!text-xl text-cement-600">article</Icon>
    <span>Session summary</span>
  </Link>
);

export default SummaryLink;
